import { Pipe, PipeTransform } from '@angular/core';
import { MerchantPaymentMethodDto } from '@up/data';

// NOTE: Currently this pipe is not used in use.
// TODO: Remove the pipe after 03.12.2021 if still not used.
@Pipe({
  name: 'availablePaymentMethods'
})
export class AvailablePaymentMethodsPipe implements PipeTransform {
  transform(
    allPaymentMethods: MerchantPaymentMethodDto[],
    ...args: any[]
  ): MerchantPaymentMethodDto[] {
    if (!args || !args.length || !args[0].length) {
      return allPaymentMethods;
    }

    return (
      allPaymentMethods.filter(
        (x) =>
          !args[0].map((p: MerchantPaymentMethodDto) => p.id).includes(x.id) &&
          x.enableSplitPayment
      ) || allPaymentMethods
    );
  }
}
